module.exports = __webpack_public_path__ + "img/830.5773d31b.svg";